import { ADD_APPOINTMENT } from "./types";

let initialState = {
    appointments: [],
};

const appointmentReducer = (state = initialState,action) => {
    switch (action.type) {
        case ADD_APPOINTMENT:
            return {
                ...state,
                appointments: [...state.appointments, action.payload]
            };
        default:
            return state;
    }
}

export default appointmentReducer;